import { type ISelectedBeneficiary, type IUseAccessCredentialsRequest, showToast } from 'BreetHelpers';
import { useDisableAutoSettlementMutation, useUpdateAutoSettlementMutation } from 'BreetRedux';
import { useCallback } from 'react';

export const useAutoSettlementApi = (selectedBeneficiary?: ISelectedBeneficiary) => {
	const [updateAutoSettlement] = useUpdateAutoSettlementMutation();

	const [disableAutoSettlement] = useDisableAutoSettlementMutation();

	const handleAutomaticSettlement = useCallback(
		(data?: IUseAccessCredentialsRequest) => {
			const beneficiaryId = selectedBeneficiary?.id ?? '';
			const isAutoSettlement = !!selectedBeneficiary?.autoSettlement;

			if (beneficiaryId && isAutoSettlement) {
				disableAutoSettlement({ bankId: beneficiaryId })
					.unwrap()
					.then(() => {
						showToast('success', 'Automatic settlement disabled successfully 🎉');

						data?.onSuccess?.();
					})
					.catch((e: unknown) => data?.onError(e));
			} else if (beneficiaryId) {
				updateAutoSettlement({ bankId: beneficiaryId })
					.unwrap()
					.then(() => {
						showToast('success', 'Automatic settlement enabled successfully 🎉');
						data?.onSuccess?.();
					})
					.catch((e: unknown) => data?.onError(e));
			}
		},
		[disableAutoSettlement, selectedBeneficiary, updateAutoSettlement]
	);

	return handleAutomaticSettlement;
};
